import { Inject, Injectable, NgModule } from '@angular/core';
import { HttpClient } from './http.service';
import { Observable } from 'rxjs';
import { Folder } from '../treeable/shared/folder.model';
import { File } from '../file/file.model';
import { NotificationService } from './notification.service';
/**
 * SiteBrowserService will allows operations against the set dotCMS Site/Host for Tree operations. Treeable assets
 * in dotCMS are anything that live on a host/folder.
 */
var SiteBrowserService = (function () {
    function SiteBrowserService(httpClient, notificationService) {
        this.httpClient = httpClient;
        this.notificationService = notificationService;
    }
    /**
     * Returns the Treeable assets (files, folders) under a host/folder
     * @param siteName dotCMS Site to load assets for
     * @returns {Observable<R>} Gets the Treeable objects. If a file the Treeable will be file as file extends Treeable
     */
    SiteBrowserService.prototype.getTreeableAssetsUnderSite = function (siteName) {
        var _this = this;
        return this.httpClient.get('/api/v1/browsertree/sitename/' + siteName + '/uri//')
            .map(function (res) { return _this.extractDataFilter(res); })
            .catch(function (error) { return _this.handleError(error); });
    };
    /**
     * Returns the Treeable assets (files, folders) under a host/folder
     * @param siteName dotCMS Site to load assets for
     * @param uri Path to load assets from
     * @returns {Observable<R>} Gets the Treeable objects. If a file the Treeable will be file as file extends Treeable
     */
    SiteBrowserService.prototype.getTreeableAssetsUnderFolder = function (siteName, uri) {
        var _this = this;
        return this.httpClient.get('/api/v1/browsertree/sitename/' + siteName + '/uri/' + uri)
            .map(function (res) { return _this.extractDataFilter(res); })
            .catch(function (error) { return _this.handleError(error); });
    };
    SiteBrowserService.prototype.extractDataFilter = function (res) {
        var treeables = [];
        var obj = JSON.parse(res.text());
        var results = obj.entity.result;
        for (var i = 0; i < results.length; i++) {
            var r = results[i];
            var t = void 0;
            if (r.type === 'folder') {
                t = Object.assign(new Folder(), r);
            }
            else if (r.type === 'file_asset') {
                t = Object.assign(new File(), r);
            }
            treeables[i] = t;
        }
        return treeables;
    };
    SiteBrowserService.prototype.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        if (errMsg) {
            console.error(errMsg);
            this.notificationService.displayErrorMessage('There was an error; please try again : ' + errMsg);
            return Observable.throw(errMsg);
        }
    };
    return SiteBrowserService;
}());
export { SiteBrowserService };
SiteBrowserService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['httpClient',] },
    { type: Inject, args: ['notificationService',] },
];
/** @nocollapse */
SiteBrowserService.ctorParameters = function () { return [
    { type: HttpClient, },
    { type: NotificationService, },
]; };
var DotSiteBrowserModule = (function () {
    function DotSiteBrowserModule() {
    }
    return DotSiteBrowserModule;
}());
export { DotSiteBrowserModule };
DotSiteBrowserModule.decorators = [
    { type: NgModule, args: [{
                providers: [SiteBrowserService, HttpClient, NotificationService]
            },] },
];
/** @nocollapse */
DotSiteBrowserModule.ctorParameters = function () { return []; };
//# sourceMappingURL=site-browser.service.js.map